module.exports = __webpack_public_path__ + "871b1543139c74448af1354dfea0b72c.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/coloring/nl4.pdf
// module id = 934
// module chunks = 3